module.exports = __webpack_public_path__ + "images/xl_gansu.png?4fe63180458a38f448c9c232e2902e84";


//////////////////
// WEBPACK FOOTER
// ./src/images/xl_gansu.png
// module id = 236
// module chunks = 1